module.exports = __webpack_public_path__ + "img/kcorder.6503c244.png";